const OfferScopePageLangKey = [
	'notification_unscoped_offers_count',
	'notification_unscoped_offers_title',
	'btn_add_new'
] as const

type IOfferScopePageLangKey = typeof OfferScopePageLangKey[number]

export type IOfferScopePageLang = {
	offer_scope_page: Record<IOfferScopePageLangKey, string>
}

const langEntries = OfferScopePageLangKey.map(
	(key: IOfferScopePageLangKey) => [key, `offer_scope_page.${key}`]
)

const langObj: Record<IOfferScopePageLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SCOPE_PAGE_LANG_KEY: IOfferScopePageLang = {
	offer_scope_page: langObj
}
